<div class="u-relative">
  @if(showTooltip){
  <div class="box video-list">
    <ul>
      @if(recordVideoSD){
        <li (click)="record('640x480')" [translate]="'VIDEO.RECORD_SD'"></li>
      }
      @if(recordVideoHD){
        <li (click)="record('1280x720')" [translate]="'VIDEO.RECORD_hD'"></li>
      }
    </ul>
  </div>
  }
</div>
@if(archives && showVideoList){
  
  <div class="form-container box">
    <div class="tooltip-inner">
      <div class="title" [translate]="'VIDEO.VIDEO_LIST.TITLE'"></div>
      <div class="subtitle" [translate]="'VIDEO.VIDEO_LIST.SUBTITLE'"></div>
      @if(archives){
        <div class="video-container">
          @for(archive of archives; track $index){

            <div class="tooltip-video-row">
              <div class="tooltip-video-name" (click)="goToVideo(archive.url)">{{ archive.createdAt }}</div>
              <div class="tooltip-video-icons">
                <i class="icon-download" (click)="goToVideo(archive.url)"></i>
                <i class="icon-trash" (click)="deleteArchive(archive.id)"></i>
              </div>
            </div>
          }
        </div>
      }
  
      <div class="u-flex u-flex-justify-content-end">
        <button class="btn btn-primary btn-lg" [translate]="'HEADER.INVITE_FORM.BUTTONS.CANCEL'"
          (click)="cancel($event)"></button>
      </div>
    </div>
  </div>
}